import { withAuthenticationRequired } from '@tom-ui/utils'
import { ContainerYardOperationDialog } from '@host/components/container-change-position-dialog/ContainerYardOperationDialog'
import { ContainerYardOperationViewStore } from '@host/components/container-change-position-dialog/ContainerYardOperationViewStore'
import { HandleOrderPage } from '@tom-ui/planning'
import { useMemo } from 'react'

export const EditOrdersPageWrapper = withAuthenticationRequired(() => {
  const containerYardOperationViewStore = useMemo(() => {
    return new ContainerYardOperationViewStore()
  }, [])

  return (
    <>
      <HandleOrderPage containerYardOperationViewStore={containerYardOperationViewStore} />
      <ContainerYardOperationDialog store={containerYardOperationViewStore} />
    </>
  )
})
